import Model, { attr } from '@ember-data/model';

import type { VerificationInfo } from 'webapp/utils/verification';

import type { ExpressionDetailItem, MetricDefinition } from 'webapp/models-custom/script';

export default class ScriptRecord extends Model {
	@attr('string') name!: string;
	@attr('string', { defaultValue: 'My calculated metric' }) description!: string;
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	metricDefinition!: MetricDefinition;
	@attr('number') created!: number;
	@attr('number') createdById!: number;
	@attr('number') modified!: number | null;
	@attr('number') modifiedById!: number | null;
	@attr('string', { defaultValue: '' }) expression!: string;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	expressionDetails!: ExpressionDetailItem[];
	@attr('number') sourceId!: number;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	tags!: number[];
	@attr('number') originateFrom!: number;
	@attr('string') timezone!: string | null;
	@attr('object') verificationInfo?: VerificationInfo;
}
